import {
	Pagination,
	PaginationButton,
	PaginationContent,
	PaginationEllipsis,
	PaginationFirst,
	PaginationItem,
	PaginationLast,
	PaginationNext,
	PaginationPrevious,
} from '@playbooks/ui/components/pagination';

const PagePagination = ({ compact = false, meta, params, setParams }) => {
	// Computed
	const page = Math.max(Number(meta?.page) || 0, 0);
	const pageSize = Math.max(Number(meta?.pageSize) || 1, 1);
	const totalRecords = Math.max(Number(meta?.totalRecords) || 0, 0);
	const totalPages = Math.max(Math.ceil(totalRecords / pageSize), 1);
	const lastPage = totalPages - 1;
	const compactPages = (() => {
		if (totalPages <= 6) return Array.from({ length: totalPages }, (_, index) => index);
		if (page <= 2) return [0, 1, 2, 3, 'end-gap', lastPage];
		if (page >= lastPage - 2) return [0, 'start-gap', lastPage - 3, lastPage - 2, lastPage - 1, lastPage];
		return [0, 'start-gap', page - 1, page, page + 1, 'end-gap', lastPage];
	})();
	const firstVisiblePage = Math.min(Math.max(page - 2, 0), Math.max(totalPages - 5, 0));
	const defaultPages = Array.from({ length: Math.min(totalPages, 5) }, (_, index) => firstVisiblePage + index);
	const pages = compact ? compactPages : defaultPages;

	// Render
	return (
		<Pagination className={compact ? 'w-auto' : ''}>
			<PaginationContent className={compact ? 'gap-0 rounded-control border border-border p-0.5' : 'gap-0.5'}>
				{!compact && (
					<PaginationItem>
						<PaginationFirst disabled={page <= 0} onClick={() => setParams({ ...params, page: 0 })} />
					</PaginationItem>
				)}
				<PaginationItem>
					<PaginationPrevious disabled={page < 1} onClick={() => setParams({ ...params, page: page - 1 })} />
				</PaginationItem>
				{pages.map(value =>
					typeof value === 'string' ? (
						<PaginationItem key={value}>
							<PaginationEllipsis />
						</PaginationItem>
					) : (
						<PaginationItem key={value}>
							<PaginationButton active={page === value} onClick={() => setParams({ ...params, page: value })}>
								{value + 1}
							</PaginationButton>
						</PaginationItem>
					),
				)}
				<PaginationItem>
					<PaginationNext disabled={page >= lastPage} onClick={() => setParams({ ...params, page: page + 1 })} />
				</PaginationItem>
				{!compact && (
					<PaginationItem>
						<PaginationLast disabled={page >= lastPage} onClick={() => setParams({ ...params, page: lastPage })} />
					</PaginationItem>
				)}
			</PaginationContent>
		</Pagination>
	);
};

export { PagePagination };
